module.exports = __webpack_public_path__ + "static/media/shape-dots-1.910eaa17.svg";